export const DASHBOARD_FILTERS = "dashboardFilters";